R = require 'ramda'

makeCondition = (condition) ->
  field: condition[0]
  op: condition[1]
  value: condition[2]

makeDefaultList = (type, name, appliesTo, polling, sounds, sortProp, sortAsc, soundName, conditions...) ->
  name: name
  type: type
  locked: true
  appliesTo: appliesTo
  isPolling: polling
  useSounds: sounds
  sortProp: { prop: sortProp, asc: sortAsc }
  soundName: soundName
  conditions: R.map makeCondition, conditions

isConfig = R.contains 'config'
isSupport = R.contains 'support'
isRestaurantAdmin = R.contains 'restaurant_admin'
isRestaurantOwner = R.contains 'restaurant'
isRestaurantStaff = R.contains 'restaurant_staff'
isRestaurant = R.anyPass [isRestaurantAdmin, isRestaurantOwner, isRestaurantStaff]
isAmbassador = R.contains 'ambassador'
isDispatcher = R.contains 'dispatcher'

makeDefaultLists = (roles, acls)->
  lists = []
  makeList = R.partial makeDefaultList, ['lists']

  if isConfig(roles) or isSupport(roles) or isAmbassador(roles) or isRestaurantAdmin(roles)
    lists.push makeList "Pending Attention", "all", true, true, "time", true, 'notification',
      [ "time", "within", { count: 14, unit: 'day' } ],
      [ "state", "!equal", "confirmed"],
      [ "state", "!equal", "rejected"],
      [ "state", "!equal", "executing"]
      [ "state", "!equal", "invoiced"]

    lists.push makeList "Lost", "all", true, true, "time", true, 'notification',
      [ "time", "within past", {count: 7, unit: 'day'} ],
      [ "state", "equal", "missed"]

  else if isRestaurant( roles )
      lists.push makeList "Unconfirmed Orders", "any", true, true, "time", true, 'neworder',
      [ "created_at", "within past", {count: 7, unit: 'day'}],
      [ "state", "equal", "executing"],
      [ "state", "equal", "missed"]

    lists.push makeList "Upcoming Orders for Today", "all", true, false, "time", true, 'notification',
      [ "time", "within", {count: 1, unit: 'day'} ],
      [ "state", "equal", "confirmed" ]

    lists.push makeList "Canceled", "all", true, true, "time", true, 'notification',
      [ "time", "within", {count: 1, unit: 'month'}],
      [ "state", "equal", "canceled"]

    lists.push makeList "Past", "all", false, false, "time", false, 'notification',
      [ "time", "within past", {count: 1, unit: 'month'}],
      [ "state", "!equal", "rejected"]

    lists.push makeList "Orders Placed Today", "all", false, false, "created_at", false, 'notification',
      [ "created_at", "~=", "today" ],
      [ "state", "!equal", "confirmed" ]

  lists

makeDefaultRdsLists = (roles) ->
  []

module.exports =
  makeDefaultLists: makeDefaultLists
  makeDefaultRdsLists: makeDefaultRdsLists
